import React, { memo, FC, useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { FormikErrors, FormikTouched, FormikValues } from 'formik';
import { useStyles } from '../../styles';
import { ValueLabel } from '../../../../../models';
import { LinkConfiguration } from '../../../RegistrationLinksModel';
import { useAppData } from '../../../../../providers';
import { getOptions } from '../../../../../utils';
import { InputField, SelectField } from '../../../../../components';

interface Props {
  linkConfigurations: LinkConfiguration[];
  touched?: FormikTouched<FormikValues>;
  errors?: FormikErrors<FormikValues>;
}

export const CreateMLMLinkTab: FC<Props> = memo(({ linkConfigurations, touched, errors }) => {
  const [mlmOptions, setMlmOptions] = useState<ValueLabel[]>([]);
  const classes = useStyles();
  const { translations } = useAppData();
  const [translation, setTranslation] = useState<any>([]);

  useEffect(() => {
    setTranslation(JSON.parse(translations));
  }, [translations]);

  useEffect(() => {
    setMlmOptions(getOptions(linkConfigurations, 'schemeName', 'configurationId'));
  }, [linkConfigurations]);

  return (
    <>
      <Grid item xs={12}>
        <InputField name="linkName" label={translation.link_name} />
      </Grid>
      <Grid item xs={6}>
        <div className={classes.fieldContainer}>
          <SelectField name="linkConfigurationId" label={translation.text_395} errors={touched?.linkConfigurationId ? errors?.linkConfigurationId : undefined} options={mlmOptions} isRequired />
        </div>
      </Grid>
      <Grid item xs={6}>
        <div className={classes.shortcodeContainer}>
          <InputField
            name="shortCode"
            label={translation.text_396}
            // icon={
            //   <LightTooltip title={translation.text_397}>
            //     <InfoOutlined className={classes.input} />
            //   </LightTooltip>
            // }
            errors={touched?.shortCode ? errors?.shortCode : undefined}
            // inputClass={classes.inputRoot}
          />
        </div>
      </Grid>
    </>
  );
});
